import React, { useState, useEffect, forwardRef, useRef } from 'react'
import styled from 'styled-components'
import { MenuItem, Dropdown } from 'react-bootstrap'
import i18n from 'live/services/i18n'

const Toggle = forwardRef((props: any, ref) => {
    const handleClick = e => {
        props.onClick()
    }

    return (
        <WrapperToogle onClick={handleClick}>
            <i className={props?.icon} />
        </WrapperToogle>
    )
})

type IProps = {
    icon: string
    data: { title: string; url: string; icon: string }[]
}

const SimpleDropdown = ({ icon = 'far fa-ellipsis-v"', data = [] }: IProps) => {
    return (
        <CustomDropdown id={`simple-dropdown`}>
            <Toggle bsRole="toggle" icon={icon} />

            <Dropdown.Menu open={true}>
                {data.map(({ title = '', url = '', icon = '' }, index) => {
                    return (
                        <CustomMenuItem key={index} href={url}>
                            <i className={icon} />
                            {i18n(title)}
                        </CustomMenuItem>
                    )
                })}
            </Dropdown.Menu>
        </CustomDropdown>
    )
}

export default SimpleDropdown

const CustomDropdown = styled(Dropdown)`
    .dropdown-menu {
        padding: 0 !important;
        margin: 0 !important;
        top: 36px !important;
        left: -181px !important;
    }
`

const CustomMenuItem = styled(MenuItem)`
    a {
        padding: 8px 16px !important;
        color: ${({ theme }) => theme['gray-800']} !important;
        font-family: ${({ theme }) => theme['font-regular']} !important;
        font-size: 13px !important;
        font-style: normal !important;
        font-weight: 400 !important;

        i {
            margin-right: 8px;
            color: ${({ theme }) => theme['gray-600']} !important;
        }
    }

    &:hover {
        background-color: ${({ theme }) => theme['blue-200']};
    }
`

const WrapperToogle = styled.div`
    padding: 16px;
    cursor: pointer;
    font-size: 16px;
    font-weight: 400;
    color: ${({ theme }) => theme['blue-500']};

    &:hover {
        background-color: ${({ theme }) => theme['gray-100']};
    }
`
